module.exports = __webpack_public_path__ + "img/marketing.c917f31b.svg";